module.exports = __webpack_public_path__ + "media/images/emblems/Cugy-VD-coat_of_arms-0fb7f4c2d6ae4865b0890657d783bf96.svg";